module.exports = __webpack_public_path__ + "static/colo_ring-21d547a7fb566fe6faaa0549d34d3e62.gif";